/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Reveal_Shownonce3Inputs */

const en_settings_reportingapikeys_reveal_shownonce3 = /** @type {(inputs: Settings_Reportingapikeys_Reveal_Shownonce3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This key is shown only once. It cannot be retrieved later – not by you, not by Vega. If it is lost, rotate the key to generate a new one.`)
};

/**
* | output |
* | --- |
* | "This key is shown only once. It cannot be retrieved later – not by you, not by Vega. If it is lost, rotate the key to generate a new one." |
*
* @param {Settings_Reportingapikeys_Reveal_Shownonce3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_reveal_shownonce3 = /** @type {((inputs?: Settings_Reportingapikeys_Reveal_Shownonce3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Reveal_Shownonce3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_reveal_shownonce3(inputs)
});
export { settings_reportingapikeys_reveal_shownonce3 as "settings_reportingApiKeys_reveal_shownOnce" }